webpackJsonp([4],{

/***/ 788:
/* exports provided: default */
/* exports used: default */
/*!************************************************************!*\
  !*** ./screens/App/components/ScalableMedia/ScaleMedia.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(/*! promise-polyfill */ 790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * ScaleMedia
 *
 * The below functions assume the container will dictate the minimum, required
 * resolution when scaling media. The .js-scale-media-container class should be
 * added to a parent element of .js-scale-media for this reason. A fallback
 * 'crop' class can be added to the HTML for when JavaScript is turned off.
 */

var scaleMedia = function () {
  function scaleMedia(el) {
    _classCallCheck(this, scaleMedia);

    this.el = el;
    this.el.classList.add('js-scale-media');
    this.mediaType = this.el.tagName.toLowerCase();
    this.findAncestor(this.el, 'js-scale-media-container');
    this.resize();
  }

  _createClass(scaleMedia, [{
    key: 'findAncestor',
    value: function findAncestor(el, className) {
      var parent = el;
      while (!parent.classList.contains(className)) {
        parent = parent.parentElement;
      }
      this.container = parent;
    }
  }, {
    key: 'resize',
    value: function resize() {
      var _this = this;

      var el = this.el;

      var resizeFn = this.resize.bind(this);
      var containerWidth = this.container.offsetWidth;
      var containerHeight = this.container.offsetHeight;
      var mediaWidth = 0;
      var mediaHeight = 0;
      var elPromise = null;

      // Get the natural dimensions.
      switch (this.mediaType) {
        case 'img':
          mediaWidth = el.naturalWidth;
          mediaHeight = el.naturalHeight;
          break;
        case 'video':
          mediaWidth = el.videoWidth;
          mediaHeight = el.videoHeight;
          break;
        default:
          // Only images and video elements are allowed.
          return;
      }

      // Try again once the media is loaded.
      if (mediaWidth <= 0 || mediaHeight <= 0) {
        if (this.mediaType === 'img') {
          elPromise = new __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a(function (resolve, reject) {
            el.onload = function () {
              return resolve({ status: 'ok' });
            };
            el.onerror = function () {
              return reject({ status: 'error' });
            };
          });
        } else {
          elPromise = new __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a(function (resolve, reject) {
            el.onloadeddata = function () {
              return resolve({ status: 'ok' });
            };
            el.onerror = function () {
              return reject({ status: 'error' });
            };
          });
        }

        elPromise.then(function () {
          resizeFn();
        }).catch(function () {
          // Fallback to using the container dimensions.
          if (containerWidth > containerHeight) {
            _this.cropHeight();
          } else {
            _this.cropWidth();
          }
        });
        return;
      }

      // Add the appropriate media scaling class.
      if (mediaWidth * containerHeight / mediaHeight < containerWidth) {
        this.cropHeight();
      } else {
        this.cropWidth();
      }
    }
  }, {
    key: 'cropHeight',
    value: function cropHeight() {
      this.el.classList.remove('js-scale-media--crop-width');
      this.el.classList.add('js-scale-media--crop-height');
    }
  }, {
    key: 'cropWidth',
    value: function cropWidth() {
      this.el.classList.remove('js-scale-media--crop-height');
      this.el.classList.add('js-scale-media--crop-width');
    }
  }]);

  return scaleMedia;
}();

/* harmony default export */ __webpack_exports__["a"] = (scaleMedia);

/***/ }),

/***/ 789:
/* exports provided: default */
/* exports used: default */
/*!*******************************************************!*\
  !*** ./screens/App/components/ScalableMedia/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScaleMedia__ = __webpack_require__(/*! ./ScaleMedia */ 788);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ScalableMedia = function (_PureComponent) {
  _inherits(ScalableMedia, _PureComponent);

  function ScalableMedia(props) {
    _classCallCheck(this, ScalableMedia);

    var _this = _possibleConstructorReturn(this, (ScalableMedia.__proto__ || Object.getPrototypeOf(ScalableMedia)).call(this, props));

    _this.media = [];
    return _this;
  }

  _createClass(ScalableMedia, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setupMedia();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setupMedia();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.media.length) {
        this.media = [];
        global.removeEventListener('resize', this.resizeMedia.bind(this));
      }
    }
  }, {
    key: 'setupMedia',
    value: function setupMedia() {
      if ('objectFit' in global.document.documentElement.style === false) {
        var media = this.div.querySelectorAll('img, video');

        if (media.length) {
          this.media = [];
          for (var i = 0; i < media.length; i += 1) {
            this.media[i] = new __WEBPACK_IMPORTED_MODULE_2__ScaleMedia__["a" /* default */](media[i]);
          }

          global.addEventListener('resize', this.resizeMedia.bind(this));
        }
      }
    }
  }, {
    key: 'resizeMedia',
    value: function resizeMedia() {
      if (this.media.length) {
        for (var i = 0; i < this.media.length; i += 1) {
          this.media[i].resize();
        }
      }
    }

    /* eslint-disable react/no-danger */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        ref: function ref(_ref) {
          _this2.div = _ref;
        },
        className: this.props.className,
        dangerouslySetInnerHTML: { __html: this.props.children }
      });
    }
    /* eslint-enable react/no-danger */

  }]);

  return ScalableMedia;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ScalableMedia.defaultProps = {
  children: '',
  className: ''
};
ScalableMedia.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (ScalableMedia);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../../../~/webpack/buildin/global.js */ 18)))

/***/ }),

/***/ 790:
/* no static exports found */
/* exports used: default */
/*!****************************************!*\
  !*** ../~/promise-polyfill/promise.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}
  
  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new (this.constructor)(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    return new Promise(function (resolve, reject) {
      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
      var args = Array.prototype.slice.call(arr);
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
    function (fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../timers-browserify/main.js */ 792).setImmediate))

/***/ }),

/***/ 791:
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ../~/setimmediate/setImmediate.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/global.js */ 18), __webpack_require__(/*! ./../process/browser.js */ 112)))

/***/ }),

/***/ 792:
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ../~/timers-browserify/main.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(/*! setimmediate */ 791);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/global.js */ 18)))

/***/ }),

/***/ 793:
/* exports provided: default */
/* exports used: default */
/*!*************************************************************!*\
  !*** ./screens/App/components/StorylinePagination/index.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_event__ = __webpack_require__(/*! custom-event */ 111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_custom_event__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var StorylinePagination = function (_PureComponent) {
  _inherits(StorylinePagination, _PureComponent);

  function StorylinePagination(props) {
    _classCallCheck(this, StorylinePagination);

    var _this = _possibleConstructorReturn(this, (StorylinePagination.__proto__ || Object.getPrototypeOf(StorylinePagination)).call(this, props));

    _this.state = {
      previous: {
        x: -100,
        y: -100
      },
      next: {
        x: -100,
        y: -100
      }
    };
    return _this;
  }

  _createClass(StorylinePagination, [{
    key: 'positionPreviousCursor',
    value: function positionPreviousCursor(event) {
      this.setState({
        previous: {
          x: event.clientX + 'px',
          y: event.clientY + 'px'
        }
      });
    }
  }, {
    key: 'positionNextCursor',
    value: function positionNextCursor(event) {
      this.setState({
        next: {
          x: event.clientX + 'px',
          y: event.clientY + 'px'
        }
      });
    }

    /* eslint-disable react/jsx-no-bind */

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'site-content__pagination site-content__screen site-content__screen--fixed' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'visually-hidden' },
          'Storyline Pagination'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'btn btn--default btn--small btn--half-page btn--half-page--previous',
            onMouseMove: this.positionPreviousCursor.bind(this),
            onClick: function onClick(event) {
              event.preventDefault();
              global.dispatchEvent(new __WEBPACK_IMPORTED_MODULE_1_custom_event___default.a('previousStoryline'));
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              className: 'btn__cursor svg-wrapper animate--rotating-clockwise',
              style: {
                top: this.state.previous.y,
                left: this.state.previous.x
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'svg',
              {
                role: 'img',
                'aria-labelledby': 'site-content-pagination-previous',
                focusable: 'false'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'title',
                { id: 'site-content-pagination-previous' },
                'Previous'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use', { xlinkHref: '#icon-forward' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'btn__child center center--both' },
              'Prev'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'btn btn--default btn--small btn--half-page btn--half-page--next',
            onMouseMove: this.positionNextCursor.bind(this),
            onClick: function onClick(event) {
              event.preventDefault();
              global.dispatchEvent(new __WEBPACK_IMPORTED_MODULE_1_custom_event___default.a('nextStoryline'));
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              className: 'btn__cursor svg-wrapper animate--rotating-counter-clockwise',
              style: {
                top: this.state.next.y,
                left: this.state.next.x
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'svg',
              {
                role: 'img',
                'aria-labelledby': 'site-content-pagination-next',
                focusable: 'false'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'title',
                { id: 'site-content-pagination-next' },
                'Next'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use', { xlinkHref: '#icon-forward' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'btn__child center center--both' },
              'Next'
            )
          )
        )
      );
    }
    /* eslint-enable react/jsx-no-bind */

  }]);

  return StorylinePagination;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (StorylinePagination);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../../../~/webpack/buildin/global.js */ 18)))

/***/ }),

/***/ 798:
/* exports provided: default */
/* all exports used */
/*!********************************************************************!*\
  !*** ./screens/App/screens/SplatRouter/screens/Story/component.js ***!
  \********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(/*! react-helmet */ 352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(/*! prop-types */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_custom_event__ = __webpack_require__(/*! custom-event */ 111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_custom_event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_custom_event__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Html__ = __webpack_require__(/*! Html */ 211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ScalableMedia__ = __webpack_require__(/*! ScalableMedia */ 789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_StorylinePagination__ = __webpack_require__(/*! StorylinePagination */ 793);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Story = function (_PureComponent) {
  _inherits(Story, _PureComponent);

  function Story() {
    _classCallCheck(this, Story);

    return _possibleConstructorReturn(this, (Story.__proto__ || Object.getPrototypeOf(Story)).apply(this, arguments));
  }

  _createClass(Story, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      global.dispatchEvent(new __WEBPACK_IMPORTED_MODULE_3_custom_event___default.a('runKineticAnimations'));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      global.dispatchEvent(new __WEBPACK_IMPORTED_MODULE_3_custom_event___default.a('runKineticAnimations'));
    }

    /* eslint-disable react/no-danger */

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'main',
        {
          className: 'site-content theme--' + this.props.fieldThemeColor + ' animate--fade-in-default'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,
          { title: this.props.entityLabel },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta', {
            property: 'og:title',
            content: this.props.entityLabel + ' | Ferguson Voices'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'site-content__teaser centered title-teaser' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'title-teaser__svg svg-wrapper svg-wrapper--left-double-quote js-kinetic-animation hide-on-mobile' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'svg',
              { 'aria-hidden': 'true', focusable: 'false' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use', { xlinkHref: '#left-double-quote' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_Html__["a" /* default */],
            { className: 'title-teaser__description h2 theme--white js-kinetic-animation hide-on-mobile' },
            this.props.fieldShortDescription
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', {
            className: 'title-teaser__title h4 h4--medium theme--white js-kinetic-animation',
            dangerouslySetInnerHTML: { __html: this.props.title }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', {
            className: 'title-teaser__subtitle h3 h3--medium js-kinetic-animation',
            dangerouslySetInnerHTML: { __html: this.props.fieldSubtitle }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_ScalableMedia__["a" /* default */],
          { className: 'site-content__hero site-content__screen site-content__screen--fixed site-content--bottom-gradient js-scale-media-container' },
          this.props.fieldImage
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'site-content__more-info site-content__screen site-content__screen--fixed' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_ScalableMedia__["a" /* default */],
            { className: 'screen screen--right screen--fixed js-scale-media-container hide-on-tablet' },
            this.props.fieldImage2
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            id: 'more-info',
            className: 'site-content__more-info site-content__screen site-content__screen--fill theme__gradient'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'screen screen--left screen--padding theme__bg wysiwyg theme--white' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'mobile-title hide-on-desktop' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                className: 'h4 h4--medium',
                dangerouslySetInnerHTML: { __html: this.props.title }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                className: 'h3 h3--medium theme--darkest-blue',
                dangerouslySetInnerHTML: { __html: this.props.fieldSubtitle }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_Html__["a" /* default */],
              null,
              this.props.body
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_StorylinePagination__["a" /* default */], null)
      );
    }
    /* eslint-enable react/no-danger */

  }]);

  return Story;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Story.defaultProps = {
  entityLabel: '',
  // fieldMetaTags: '',
  title: '',
  body: '',
  fieldImage: '',
  fieldImage2: '',
  fieldSubtitle: '',
  fieldThemeColor: '',
  fieldShortDescription: ''
};
Story.propTypes = {
  entityLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  // fieldMetaTags: PropTypes.string,
  title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  body: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  fieldImage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  fieldImage2: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  fieldSubtitle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  fieldThemeColor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  fieldShortDescription: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["default"] = (Story);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../../../../../~/webpack/buildin/global.js */ 18)))

/***/ })

});


// WEBPACK FOOTER //
// Story/component.378f639eae8f3a21b8cf.js